import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_chauffeur-prive-29/artifacts/ebdff0165cb41c3c_Van%20D%27Iroise.jpg";

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f7f2]">
      {/* Header */}
      <header className="bg-[#1a1d2e] py-5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Van d'Iroise"
              className="h-[48px] w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[14px] text-white/70 hover:text-[#c9a84c] transition-colors duration-200"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            <ArrowLeft size={16} />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[860px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <h1
          className="text-[32px] md:text-[40px] font-normal text-[#1a1d2e] leading-[1.2] mb-4"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Mentions légales
        </h1>
        <div className="gold-line mb-10" />

        <p
          className="text-[15px] text-[#555] leading-[1.8] mb-10"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, dite L.C.E.N., il est porté à la connaissance des utilisateurs et visiteurs du site les présentes mentions légales.
        </p>

        {/* Éditeur du site */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Éditeur du site
          </h2>
          <div className="border-l-2 border-[#c9a84c] pl-6">
            <div className="space-y-1.5 text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <p className="font-medium text-[#1a1d2e]">VTC29</p>
              <p>EI M. Vincent TIXIER</p>
              <p>SIRET : 84204516300016</p>
              <p>Siège social : 13 AVENUE DE WALTENHOFEN, 29860 PLABENNEC</p>
              <p>
                Email :{" "}
                <a href="mailto:vtc29chauffeurprive@gmail.com" className="text-[#c9a84c] hover:underline">
                  vtc29chauffeurprive@gmail.com
                </a>
              </p>
            </div>
          </div>
        </section>

        {/* Directeur de publication */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Directeur de publication
          </h2>
          <div className="border-l-2 border-[#c9a84c] pl-6">
            <p className="text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              M. LE MERRER Owen
            </p>
          </div>
        </section>

        {/* Hébergeur */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Hébergeur du site
          </h2>
          <div className="border-l-2 border-[#c9a84c] pl-6">
            <div className="space-y-1.5 text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <p className="font-medium text-[#1a1d2e]">IONOS SARL</p>
              <p>7 place de la Gare, BP 70109</p>
              <p>57201 Sarreguemines Cedex – France</p>
              <p>
                Site :{" "}
                <a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer" className="text-[#c9a84c] hover:underline">
                  www.ionos.fr
                </a>
              </p>
              <p>Tél. : 0970808911</p>
            </div>
          </div>
        </section>

        {/* Accès au site */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Accès au site
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Le Site est accessible en tout lieu, 7j/7, 24h/24 sauf cas de force majeure, interruption programmée ou non, et pouvant découler d'une nécessité de maintenance. En cas de modification, interruption ou suspension du Site, l'éditeur ne saurait être tenu responsable.
          </p>
        </section>

        {/* Collecte de données */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Collecte de données
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Le Site assure à l'Utilisateur une collecte et un traitement des informations personnelles dans le respect de la vie privée, conformément à la loi n°78-17 du 6 janvier 1978. L'Utilisateur peut exercer ses droits d'accès, de rectification, de suppression et d'opposition par e-mail à :{" "}
            <a href="mailto:vtc29chauffeurprive@gmail.com" className="text-[#c9a84c] hover:underline">
              vtc29chauffeurprive@gmail.com
            </a>
          </p>
        </section>

        {/* Bloctel */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Bloctel
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Conformément à l'article L.223-2 du Code de la consommation, l'Utilisateur peut s'inscrire gratuitement sur la liste d'opposition au démarchage téléphonique :{" "}
            <a href="https://www.bloctel.gouv.fr" target="_blank" rel="noopener noreferrer" className="text-[#c9a84c] hover:underline">
              www.bloctel.gouv.fr
            </a>
          </p>
        </section>

        {/* Règlement en ligne des litiges */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Règlement en ligne des litiges
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            En application du Règlement (UE) N° 524/2013, la Commission européenne met à disposition une plateforme de règlement des litiges en ligne :{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#c9a84c] hover:underline">
              https://ec.europa.eu/consumers/odr
            </a>
          </p>
        </section>

        {/* Droits de propriété intellectuelle */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Droits de propriété intellectuelle
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Toute utilisation, reproduction, diffusion, commercialisation ou modification de tout ou partie du Site, sans autorisation préalable écrite de M. Vincent TIXIER, est interdite et pourra entraîner des poursuites judiciaires.
          </p>
        </section>

        {/* Médiation des litiges */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Médiation des litiges
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Conformément aux articles L.611-1 à L.611-3 et R.612-1 à R.612-2 du Code de la consommation, tout consommateur peut recourir gratuitement à un médiateur de la consommation.
          </p>
        </section>

        {/* Crédit photo */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Crédit photo
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Les visuels utilisés sur le site sont soit la propriété exclusive de VTC29, soit issus de banques d'images libres de droit (Adobe Stock).
          </p>
        </section>
      </main>

      {/* Footer mini */}
      <footer className="bg-[#12141f] py-8">
        <div className="max-w-[860px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[12px] text-white/20"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            © {new Date().getFullYear()} Van d'Iroise — Chauffeur privé. Tous droits réservés.
          </p>
          <Link
            to="/"
            className="text-[12px] text-white/40 hover:text-[#c9a84c] transition-colors"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Retour à l'accueil
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default MentionsLegales;
